import React, { useEffect, useState } from 'react';
import {
  Card,
  Row,
  CardTitle,
  CardBody,
  Button,
  FormGroup,
  Label,
  Input,
} from 'reactstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import VendorBranchSelector from '../../components/VendorBranchSelector';
import { useSelector } from 'react-redux';
import { apiService } from '../../constants/ApiService';
import { toast } from 'react-toastify';
import useVendorBranch from '../../utils/useVendorBranch';

const AddEditSalaryDefinition = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { user } = useSelector((state) => state.authState);

  const { isSuperAdmin, isAdmin, hasMultiBranch } = useVendorBranch(user);

  const [salaryDefinitionData, setSalaryDefinitionData] = useState({
    id: 0,
    vendor_id: 0,
    branch_id: 0,
    designation: '',
    salary: '',
    leave_allowed: '',
  });

  const [errorMessage, setErrorMessage] = useState({});

  useEffect(() => {
    if (location.state) {
      setSalaryDefinitionData((prev) => ({
        ...prev,
        ...location.state,
        salary:
          location.state.salary !== null && location.state.salary !== undefined
            ? location.state.salary
            : '',
        leave_allowed:
          location.state.leave_allowed !== null &&
          location.state.leave_allowed !== undefined
            ? location.state.leave_allowed
            : '',
      }));
    }
  }, [location.state]);

  const onChangeHandle = (e) => {
    const { name, value } = e.target;

    setSalaryDefinitionData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrorMessage((prev) => ({
      ...prev,
      [name]: '',
    }));
  };

  const SaveSalaryDefinition = async () => {
    if (
      isSuperAdmin &&
      (!salaryDefinitionData.vendor_id || salaryDefinitionData.vendor_id <= 0)
    ) {
      toast.error('Please select Vendor');
      return;
    }

    if (
      (isSuperAdmin || isAdmin || hasMultiBranch) &&
      (!salaryDefinitionData.branch_id || salaryDefinitionData.branch_id <= 0)
    ) {
      toast.error('Please select Branch');
      return;
    }

    if (!salaryDefinitionData.designation?.trim()) {
      toast.error('Please enter Designation');
      return;
    }

    if (
      salaryDefinitionData.salary === '' ||
      salaryDefinitionData.salary === null ||
      Number(salaryDefinitionData.salary) <= 0
    ) {
      toast.error('Please enter valid Salary');
      return;
    }

    if (
      salaryDefinitionData.leave_allowed === '' ||
      salaryDefinitionData.leave_allowed === null ||
      Number(salaryDefinitionData.leave_allowed) < 0
    ) {
      toast.error('Please enter valid Leave Allowed');
      return;
    }

    try {
      let res;

      const payload = {
        ...salaryDefinitionData,
        vendor_id:
          salaryDefinitionData.vendor_id === '' ||
          salaryDefinitionData.vendor_id === null
            ? null
            : Number(salaryDefinitionData.vendor_id),

        branch_id:
          salaryDefinitionData.branch_id === '' ||
          salaryDefinitionData.branch_id === null
            ? null
            : Number(salaryDefinitionData.branch_id),

        salary:
          salaryDefinitionData.salary === '' ||
          salaryDefinitionData.salary === null
            ? null
            : Number(salaryDefinitionData.salary),

        leave_allowed:
          salaryDefinitionData.leave_allowed === '' ||
          salaryDefinitionData.leave_allowed === null
            ? null
            : Number(salaryDefinitionData.leave_allowed),
      };

      if (salaryDefinitionData.id && salaryDefinitionData.id > 0) {
        res = await apiService.put(
          `api/SalaryDefinition/UpdateSalaryDefinition?id=${salaryDefinitionData.id}`,
          payload,
        );
      } else {
        res = await apiService.post(
          'api/SalaryDefinition/AddSalaryDefinition',
          payload,
        );
      }

      console.log('SAVE SALARY DEFINITION RESPONSE:', res);

      if (res?.status === true) {
        toast.success(res.message || res.Message || 'Saved successfully');
        navigate('/list-salary-definition');
      } else {
        toast.error(res?.message || res?.Message || 'Failed');
      }
    } catch (err) {
      console.error(err);
      toast.error('Something went wrong');
    }
  };

  return (
    <>
      {/* SAME WEEKEND WALA VENDOR / BRANCH DROPDOWN */}
      <VendorBranchSelector
        user={user}
        selectionData={salaryDefinitionData}
        setSelectionData={setSalaryDefinitionData}
        accessButton={true}
        errorMessage={errorMessage}
      />

      <Card className='card-box pd-20 mb-20'>
        <CardTitle className='border-bottom p-3 d-flex justify-content-between align-items-center'>
          <span>Salary Definition Form</span>

          <Button color='warning' onClick={() => navigate(-1)}>
            <i className='bi bi-arrow-left' />
          </Button>
        </CardTitle>

        <CardBody>
          <Row>
            <FormGroup className='col-sm-6'>
              <Label>Designation</Label>
              <Input
                type='text'
                name='designation'
                value={salaryDefinitionData.designation || ''}
                onChange={onChangeHandle}
                placeholder='Enter Designation'
              />
            </FormGroup>

            <FormGroup className='col-sm-6'>
              <Label>Salary</Label>
              <Input
                type='number'
                name='salary'
                value={salaryDefinitionData.salary || ''}
                onChange={onChangeHandle}
                placeholder='Enter Salary'
                min='0'
                step='0.01'
              />
            </FormGroup>

            <FormGroup className='col-sm-6'>
              <Label>Leave Allowed</Label>
              <Input
                type='number'
                name='leave_allowed'
                value={salaryDefinitionData.leave_allowed || ''}
                onChange={onChangeHandle}
                placeholder='Enter Leave Allowed'
                min='0'
              />
            </FormGroup>
          </Row>

          <Button
            color='primary'
            className='float-end mt-3'
            onClick={SaveSalaryDefinition}
          >
            Save
          </Button>
        </CardBody>
      </Card>
    </>
  );
};

export default AddEditSalaryDefinition;